import React from 'react';

const About = () => {
  return (
    <div className="content-section">
      <div className="container mx-auto px-4">
        <div className="glass-card rounded-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-primary mb-6 text-center">
            About Vajreya Ventures
          </h1>
          <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-bold text-primary mb-4">Our Company</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Vajreya Ventures Private Limited is headquartered in Bangalore, Karnataka, India. Founded with a vision to provide comprehensive investment and consultancy services, we have established ourselves as a trusted partner for businesses seeking strategic growth and financial excellence.
              </p>

              <h2 className="text-2xl font-bold text-primary mb-4">Our Mission</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                To empower our clients with tailored financial and operational strategies that drive sustainable growth and create lasting value in the global marketplace.
              </p>

              <h2 className="text-2xl font-bold text-primary mb-4">Our Vision</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                To be recognized as a leading management consultancy firm, known for our integrity, expertise, and commitment to client success across diverse industries and markets.
              </p>

              <h2 className="text-2xl font-bold text-primary mb-4">Leadership</h2>
              <div className="bg-white border-2 gold-border rounded-lg p-6 mb-6">
                <h3 className="text-xl font-bold text-primary mb-2">Mayoor Shastry BN</h3>
                <p className="gold-text font-semibold mb-3">Chief Executive Officer</p>
                <p className="text-gray-700 leading-relaxed">
                  Under the visionary leadership of CEO Mayoor Shastry BN, Vajreya Ventures has positioned itself at the forefront of management consultancy and strategic investments, delivering exceptional value to clients across multiple sectors.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-primary mb-4">Our Values</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="bg-white border-2 gold-border rounded-lg p-4">
                  <h3 className="font-bold text-primary mb-2">Integrity</h3>
                  <p className="text-gray-600 text-sm">We maintain the highest standards of professional ethics and transparency in all our dealings.</p>
                </div>
                <div className="bg-white border-2 gold-border rounded-lg p-4">
                  <h3 className="font-bold text-primary mb-2">Excellence</h3>
                  <p className="text-gray-600 text-sm">We strive for excellence in every service we deliver, ensuring superior outcomes for our clients.</p>
                </div>
                <div className="bg-white border-2 gold-border rounded-lg p-4">
                  <h3 className="font-bold text-primary mb-2">Innovation</h3>
                  <p className="text-gray-600 text-sm">We embrace innovative approaches to solve complex business challenges and create opportunities.</p>
                </div>
                <div className="bg-white border-2 gold-border rounded-lg p-4">
                  <h3 className="font-bold text-primary mb-2">Partnership</h3>
                  <p className="text-gray-600 text-sm">We build lasting relationships based on trust, collaboration, and mutual success.</p>
                </div>
              </div>

              <h2 className="text-2xl font-bold text-primary mb-4">Why Choose Us</h2>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="gold-text mr-2">•</span>
                  <span>Extensive experience in strategic investments and financial services</span>
                </li>
                <li className="flex items-start">
                  <span className="gold-text mr-2">•</span>
                  <span>Comprehensive consultancy services across multiple sectors</span>
                </li>
                <li className="flex items-start">
                  <span className="gold-text mr-2">•</span>
                  <span>Global reach with local expertise</span>
                </li>
                <li className="flex items-start">
                  <span className="gold-text mr-2">•</span>
                  <span>Proven track record of successful client engagements</span>
                </li>
                <li className="flex items-start">
                  <span className="gold-text mr-2">•</span>
                  <span>Tailored solutions that address unique business needs</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;